import EmbedCodeEditing from './embed-code-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class EmbedCodeUI extends Plugin {
    init() { }
}
export default class EmbedCode extends Plugin {
    static get requires() {
        return [EmbedCodeEditing, EmbedCodeUI];
    }
}
